module.exports = __webpack_public_path__ + "static/images/containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/lightningStyle/LIGHTNING_STYLE_ussr.d858abd9.png";


//////////////////
// WEBPACK FOOTER
// ./containers/WGCWXShop/containers/WGCWXShopDetailedProduct/images/products/lightningStyle/LIGHTNING_STYLE_ussr.png
// module id = 1260
// module chunks = 16